/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 08.02.13, 17:40
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { AbstractTextContentVO } from "./AbstractTextContentVO";

/**
 *
 */
export class TextVO extends AbstractTextContentVO {
    public static NAME: string = "TextVO";

    private _stringValue: string;

    constructor(stringValue: string) {
        super();

        this._stringValue = stringValue;
    }

    public get stringValue(): string {
        return this._stringValue;
    }

    public set stringValue(value: string) {
        this._stringValue = value;

        this.propertyChangedSignal.dispatch();
    }

    public compose(): string {
        return this._stringValue;
    }

    public toString(): string {
        return TextVO.NAME + ", stringValue: " + this._stringValue;
    }
}
